import { gql } from '@apollo/client';

export const GET_ANALYTICS_SURVEY = gql`
  query Analytics(
    $projectId: ID!,
    $segmentId: ID,
    $analyticsFilterId: ID,
    $unsavedConditions: JSON
  ) {
    analytics(
      projectId: $projectId,
      segmentId: $segmentId,
      analyticsFilterId: $analyticsFilterId,
      unsavedConditions: $unsavedConditions
    ) {
      surveysAnalytics(
        projectId: $projectId,
        segmentId: $segmentId,
        analyticsFilterId: $analyticsFilterId,
        unsavedConditions: $unsavedConditions
      ) {
        id
        page
        projectId
        testerIds
        questions {
          id
          label
          questionType
          questionOrder
          leftLabel
          rightLabel
          matrix
          total
          imageUrl
          matrixType
          options {
            id
            label
            order
            count
            imageUrl
            matrixOption
            ranking {
              id
              value
            }
          }
          others {
            firstName
            valueText
          }
          firstClickCoordinates {
            x,
            y
          }
        }
      }
    }
  }
`;

// survey_analytics_filter_options
export const GET_SURVEY_ANALYTICS_FILTER_OPTIONS = gql`
  query SurveyAnalyticsFilterOptions($projectId: ID!) {
    surveyAnalyticsFilterOptions(projectId: $projectId) {
      age
      householdIncome
      country
      gender
      state
      ethnicity
    }
  }
`;

// REMOVE THIS
export const GET_ANALYTICS_OPTIONS = gql`
  query GetFilteredAnalyticsOptions(
  $projectId: ID!,
  $segmentId: ID,
  $age: [String!],
  $ageNot: [String!],
  $gender: [String!],
  $genderNot: [String!],
  $ethnicity: [String!],
  $ethnicityNot: [String!],
  $country: [String!],
  $countryNot: [String!],
  $householdIncome: [String!],
  $householdIncomeNot: [String!],
  $state: [String!],
  $stateNot: [String!],
  $questionConditions: String!
) {
  filteredAnalyticsOptions(
    projectId: $projectId,
    segmentId: $segmentId,
    age: $age,
    ageNot: $ageNot,
    gender: $gender,
    genderNot: $genderNot,
    ethnicity: $ethnicity,
    ethnicityNot: $ethnicityNot,
    country: $country,
    countryNot: $countryNot,
    householdIncome: $householdIncome,
    householdIncomeNot: $householdIncomeNot,
    state: $state,
    stateNot: $stateNot,
    questionConditions: $questionConditions
  ) {
    totalHits
    hits
    aggregations {
      ethnicityCount {
          buckets{
              docCount
              key
          }
      }
      genderCount{
          buckets{
              docCount
              key
          }
      }
      householdIncomeCount{
          buckets{
              docCount
              key
          }
      }
      countryCount{
          buckets{
              docCount
              key
          }
      }
      stateCount{
          buckets{
              docCount
              key
          }
      }
      ageCount{
          buckets{
              docCount
              key
          }
      }
    }
    globalAggregations {
      ethnicityCount {
          buckets{
              docCount
              key
          }
      }
      genderCount{
          buckets{
              docCount
              key
          }
      }
      householdIncomeCount{
          buckets{
              docCount
              key
          }
      }
      countryCount{
          buckets{
              docCount
              key
          }
      }
      stateCount{
          buckets{
              docCount
              key
          }
      }
      ageCount{
          buckets{
              docCount
              key
          }
      }
    }
  }
}
`;

export const GET_SAVED_FILTERS = gql`
  query GetSavedFilters($projectId: ID!) {
    analyticsFilters(projectId: $projectId) {
      id
      name
      conditions
    }
  }
`;

export const CREATE_ANALYTICS_FILTER = gql`
  mutation CreateAnalyticsFilter($attributes: AnalyticsFilterAttributes!) {
    createAnalyticsFilter(attributes: $attributes) {
      analyticsFilter {
        id
        name
        conditions
        project {
          id
        }
      }
    }
  }
`;

export const DELETE_ANALYTICS_FILTER = gql`
  mutation DeleteAnalyticsFilter($id: ID!) {
    deleteAnalyticsFilter(id: $id) {
      void
    }
  }
`;

export const GET_PROJECT_QUESTIONS = gql`
  query GetProjectQuestions($projectId: ID!) {
    project(id: $projectId) {
      surveys {
        questions {
          id
          label
          questionType
          questionOrder
          questionOptions {
            id
            label
          }
        }
        surveysPages {
          questions {
            id
            label
            questionType
            questionOrder
            questionOptions(preserveOrder: true) {
              id
              label
              matrixOption
            }
          }
        }
      }
      segments {
        surveys(surveyType: "screener") {
          questions {
            id
            label
            questionType
            questionOrder
            questionOptions {
              id
              label
            }
          }
        }
      }
    }
  }
`;
